<template>
	<div class="section-content" style="background: #F5F8FF;padding-top: 20px; ">
		
		<div class="page-title">
			<div >
				道佑知识
				<img src="../assets/images/home_TitleLine.png" />
			</div>
		</div>
		
		<div style="width:85%;margin:0 auto;margin-top: -2vw;">

			<div style="">
				<div style="display: flex;flex-direction: row;justify-content: space-between;">
					
				</div>

				<el-carousel ref="zcarousel" :autoplay="false" indicator-position="none" arrow="never"
					style="height: 78vh;">
					<el-carousel-item style="height: 100%;"
						v-for="(item1, index1) in detailInfo" :key="index1">
						<div style="color: #000;text-align: right;">
							<div style="cursor: pointer;" @click="gotoZS(item1)">查看往期节目<i class="el-icon-arrow-right"></i>
							</div>
						</div>
						<div style="display: flex;flex-direction: row;">
							<div
								style="width: 33.6vw;position: relative;background-color: #fff;border-radius: 8px;box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.21);    margin: 4px;" @click="gotoZS(item1)">
								<el-image fit="cover" style="border-radius: 8px 8px 0 0;margin-left: 0.1px; height: 46.2vh;width: 33.6vw;"
									:src="item1.summaryInfo.showImg"></el-image>

								<el-image fit="cover"
									style="overflow: hidden; margin-left: 0.1px;height:22.4vh; width: 33.6vw;z-index: 2;margin-top:-30px;border-radius: 30px 0 0 0 "
									:src="item1.botImg"></el-image>

								<div style="color:#fff;font-size: 13px;margin-left: 30px;margin-right: 30px;">
									<div style="width: 80%;text-align: left;height: 23.6vh;border-radius: 20px 0 0 0 ; position: absolute;z-index: 4;inset: 0;top: 45vh;left: 1.5vw;"
										v-html="item1.summaryInfo.summaryContent" class="html13">
 
									</div>
									<div style="background-color: #fff;color:#000;text-align: center;font-size: 1.5vw;">
										<i class="el-icon-caret-right" style="color:192F56"></i> {{item1.summaryInfo.title}}
									</div>
								</div>

							</div>



							<div style="display: flex;flex-wrap: wrap;height: 71.7vh;justify-content: end;">
								<div @click="gotoDetail(item)" v-for="(item,index) in item1.showList"
									style="height: 33.68vh;width: 11.8vw;background-color: #fff;margin-left:3.0vw;margin-right: 3px; display: inline-block;margin-top: 2vh;border-radius: 8px;box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.21);">
									<div style="position: relative;height: 26vh;width: 100%;">
										<el-image fit="cover"
											style="height: 26vh;width: 100%;border-radius: 8px 8px 0 0;"
											:src="item.coverImg"></el-image>
										<div
											style="color: #fff;height: 30px; width: 100%;background-color: #00000066;position: absolute;bottom: 0;left: 0;font-size: 13px;text-align: left;line-height: 30px;">
											<i style="margin-left: 10px;margin-right: 6px;"
												class="el-icon-video-camera"></i>{{item.browseNum}}
										</div>

										<div style="color: #000;font-size: 1.0vw;text-align: left;margin-left: 8px;margin-right: 8px;margin-top: 3px;text-overflow:ellipsis;
										overflow:hidden;
										display:-webkit-box;
										-webkit-line-clamp:2;	
										-webkit-box-orient:vertical;
										">
											{{item.title}}
										</div>
									</div>


								</div>
							</div>

						</div>
					</el-carousel-item>
				</el-carousel>


			</div>





			
		</div>
		
		<div style="display: flex;align-items: center;justify-content: center;margin-top: 0.5vh;">
			<div @click="clickPrev" class="normalBtn" hoverclass>
				<i class='el-icon-arrow-left'></i>
			</div>
		
			<div @click="clickNext" class="normalBtn" style="margin-left: 20px;">
				<i class='el-icon-arrow-right'></i>
			</div>
		</div>
		
		<el-dialog :visible.sync="isShowPlay" width="60%">
			<video-player class="video-player vjs-custom-skin" ref="videoUrl" style="width: 100%;border-radius: 4px;"
				:playsinline="true" :options="{
		  			  playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
		  			  autoplay: true, //如果true,浏览器准备好时开始回放。
		  			  controls: true, //控制条
		  			  preload: true, //视频预加载
		  			  muted: false, //默认情况下将会消除任何音频。
		  			  loop: false, //导致视频一结束就重新开始。
		  			  language: 'zh-CN',
		  			  aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（
		  			  fluid: true,
		  			  sources: [
		  			    {
		  			      type: 'video/mp4',
		  			      src: currentRow.videoUrl
		  			    }
		  			  ],
		  			  poster:currentRow.videoCoverImg,
		  			  notSupportedMessage: '此视频暂无法播放，请稍后再试'
		  			}"></video-player>
		</el-dialog>
	</div>

</template>

<script>
	import {
		summaryList,
		zxDetail,
		findBySearchToPeiChang
	} from '@/api/webstation.js'
	export default {
		name: 'homeOne',
		components: {

		},
		data() {
			return {
				currentPage: 0,
				currentShowData: [],
				daoyouZhiShi: [],
				shangcaiData: [],
				peichangData: [],
				dataAll: [],
				isShowPlay: false,
				currentRow: {},
				detailInfo: [
					{'summaryInfo':{},
					'showList':[],
					'id':1,
					"botImg":require('../assets/images/home_zs.png')
					},
					{'summaryInfo':{},
					'showList':[],
					'id':5,
					"botImg":require('../assets/images/home_sc.png')
					},
					{'summaryInfo':{},
					'showList':[],
					'id':6,
					"botImg":require('../assets/images/home_pc.png')
					}
				]
			}
		},
		mounted() {
			

			this.getfindBySearch()
			this.getsummaryList()
		},
		methods: {
			getsummaryList() {
				let that = this
				summaryList({
					"pageNum": "1", //当前页
					"pageSize": "1", //每页展示的条数
					"showModel": '3'
				}).then(res => {
					if (res.code == 200) {
						that.detailInfo[0].summaryInfo = res.rows[0]

					}
				})
				summaryList({
					"pageNum": "1", //当前页
					"pageSize": "1", //每页展示的条数
					"showModel": '19'
				}).then(res => {
					if (res.code == 200) {
						that.detailInfo[1].summaryInfo = res.rows[0]
				
					}
				})
				
				summaryList({
					"pageNum": "1", //当前页
					"pageSize": "1", //每页展示的条数
					"showModel": '20'
				}).then(res => {
					if (res.code == 200) {
						that.detailInfo[2].summaryInfo = res.rows[0]
				
					}
				})
			},
			gotoDetail(item) {
				// this.isShowPlay = true
				this.currentRow = item
				// zxDetail({
				// 	masterId: item.masterId
				// }).then(res => {})
				this.$router.push('/newsInfoDetail?articleId='+ item.masterId)

			},


			gotoZS(item) {
				this.$router.push({
					path: "/dyKnowlege?type=" + item.id
				});
			},
			clickPrev() {

				this.$refs['zcarousel'].prev()
			},
			clickNext() {

				this.$refs['zcarousel'].next()
			},
			getfindBySearch() {
				let that = this

				findBySearchToPeiChang({

					pageNum: 1,
					pageSize: 6,
					classifyId: 1,
					isSelect: 1,
					isAll: 1,
					isSort: 0,
					title: "",
					type: 2,
					managementId: "",
					labelId: "",
					userId: 578
				}).then(res => {
					// if (res.code == 200) {
					let data = res.titleList
					for (var i = 0; i < data.length; i++) {
						// console.log('data[i]: ', data[i]);
						let item = data[i]
						if (item.titleName == '道佑知识') {
							let shipinData = item.children.shipin
							// that.dataAll = shipinData
							that.detailInfo[0].showList = shipinData
						}
					}
				})

				findBySearchToPeiChang({

					pageNum: 1,
					pageSize: 6,
					classifyId: 5,
					isSelect: 1,
					isAll: 1,
					isSort: 0,
					title: "",
					type: 2,
					managementId: "",
					labelId: "",
					userId: 578
				}).then(res => {
					// if (res.code == 200) {
					let data = res.titleList
					for (var i = 0; i < data.length; i++) {
						// console.log('data[i]: ', data[i]);
						let item = data[i]
						if (item.titleName == '伤残鉴定') {
							let shipinData = item.children.shipin

							that.detailInfo[1].showList = shipinData
						}
					}
				})

				findBySearchToPeiChang({

					pageNum: 1,
					pageSize: 6,
					classifyId: 6,
					isSelect: 1,
					isAll: 1,
					isSort: 0,
					title: "",
					type: 2,
					managementId: "",
					labelId: "",
					userId: 578
				}).then(res => {
					// if (res.code == 200) {
					let data = res.titleList
					for (var i = 0; i < data.length; i++) {
						// console.log('data[i]: ', data[i]);
						let item = data[i]
						if (item.titleName == '赔偿方案') {
							let shipinData = item.children.shipin

							that.detailInfo[2].showList = shipinData
						}
					}
				})
			},


		}

	}
</script>

<style scoped>
	@import '../assets/home.css';

	.normalBtn {
		background-color: #999999;
		width: 38px;
		height: 38px;
		border-radius: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 28px;
	}

	.normalBtn:hover {
		background-color: #083A81;
	}
	 
	.html13 /deep/ p  {
		 
		margin: auto;
		 
		font-size: 1.0vw;
		 color: #fff; 
		text-align: left;
		display: flex;
		/* text-indent: 2em; */
		 
		
	}
</style>


// WEBPACK FOOTER //
// src/components/home_seven.vue